// Angular imports
import { Injectable } from '@angular/core';

// Import observable
import { Observable, Subscriber } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ApplicationEventService {
    private events: { [event: string]: _ApplicationEvent<any> } = {};

    constructor() { }

    public emit<T>(event: string, args?: T): ApplicationEvent<T> {
        // Create a new event if it's not registered already
        if (!(event in this.events))
            this.events[event] = new _ApplicationEvent<T>(event);

        // Emit the event
        return this.events[event].emit(args);
    }

    public get<T>(event: string): ApplicationEvent<T> {
        // Create a new event if it's not registered already
        if (!(event in this.events))
            this.events[event] = new _ApplicationEvent<T>(event);

        // Return the event
        return this.events[event];
    }
}

abstract class ApplicationEvent<T> extends Observable<T> {
    public readonly name: string;

    protected subscribers: Subscriber<T>[] = [];

    constructor(name: string) {
        super((subscriber) => {
            this.subscribers.push(subscriber);
        });

        this.name = name;
    }
}

class _ApplicationEvent<T> extends ApplicationEvent<T> {
    public emit(args?: T): this {
        // Call next on all subscribers
        this.subscribers.forEach(sub => sub.next(args));

        // Return this
        return this;
    }
}